import { BackorderReportsComponent } from './backorder-reports/backorder-reports.component';
import { AzureCurrentUsageDetailsComponent } from './azure-reporting-dashboard/azure-current-usage-details/azure-current-usage-details.component';
import { LicenseReportingDashboardComponent } from './license-reporting-dashboard/license-reporting-dashboard.component';
import { AzureReportingDetailsComponent } from './azure-reporting-dashboard/azure-reporting-details/azure-reporting-details.component';
import { AzureReportingDashboardComponent } from './azure-reporting-dashboard/azure-reporting-dashboard.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportingComponent } from './reporting.component';
import { ReportingDashboardComponent } from './reporting-dashboard/reporting-dashboard.component';
import { CustomReportEditComponent } from './custom-report-edit/custom-report-edit.component';
import { SellThroughReportsComponent } from './sell-through-reports/sell-through-reports.component';
import { OrderItemDetailComponent } from '../my-orders/order-item-detail/order-item-detail.component';
import { MakePaymentComponent } from '../my-account/make-payment/make-payment.component';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';
import { EsdReportComponent } from './esd-report/esd-report.component';
import { EsdDetailViewComponent } from './esd-report/esd-detail-view.component';
import { WebAuditLogComponent } from './web-audit-log/web-audit-log.component';
import { UpcomingMicrosoftCSPRenewalsComponent } from './upcoming-microsoft-csp-renewals/upcoming-microsoft-csp-renewals.component';
import { NCEOrderReportComponent } from './nce-orders-report/nce-orders-report.component';

const routes: Routes = [
  {
    path: 'reporting',
    component: ReportingComponent,
    data: {
      breadcrumb: 'Reporting',
    },
    children: [
      {
         path:'sellthroughreport',
         component: SellThroughReportsComponent,
         data: {
          breadcrumb: 'Sell Through Reports'
         }
      },
      {
        path:'backordersreport',
        component: BackorderReportsComponent,
        data: {
         breadcrumb: 'ETA and Backorder Reports'
        },
        children: [
          {
              path: 'orderitemdetail/:sku',
              component: OrderItemDetailComponent,
              data: {
                breadcrumb: 'sku'
              },
              children:[
                {
                  path: 'product/:sku',
                  component: ProductDetailComponent,
                  children: [
                      {
                          path: 'bundledproduct/:sku',
                          component: ProductDetailComponent,
                          data: {
                              breadcrumb: 'sku',
                          }
                      }]
                },
                {
                  path: 'payment',
                  component: MakePaymentComponent,
                  data: {
                    breadcrumb: 'Make a Payment',
                  },
                }
              ]
          }
        ]
     },
      {
        path: 'reportingdashboard/:reportType',
        component: ReportingDashboardComponent,
        data: {
          breadcrumb: 'reportType'
        }
      },
      {
        path: 'licensereportingdashboard',
        component: LicenseReportingDashboardComponent,
        data: {
          breadcrumb: 'License Usage Reports'
        }
      },
      {
        path: 'azurereportingdashboard',
        component: AzureReportingDashboardComponent,
        data: {
          breadcrumb: 'Azure Usage Reports'
        },
        children: [
          {
            path: 'azurereportingdetails',
            component: AzureReportingDetailsComponent,
            data: {
              breadcrumb: 'Usage Report Details'
            }
          },
          {
            path: 'azurecurrentusagedetails',
            component: AzureCurrentUsageDetailsComponent,
            data: {
              breadcrumb: 'Current Usage Details'
            }
          }
        ]
      },
      {
        path: 'customreporting/:type',
        component: CustomReportEditComponent,
        data: {
          breadcrumb: 'Create Custom Report'
        }    
      },
      {
        path:'esdreport',
        component: EsdReportComponent,
        data: {
         breadcrumb: 'ESD Report'
        },
        children: [
          {
            path: 'detail/:orderNo',
            component: EsdDetailViewComponent,
            data: {
              breadcrumb: 'Details'
            }
          },
          {
            path: 'detail/:orderNo/:suffix',
            component: EsdDetailViewComponent,
            data: {
              breadcrumb: 'Details'
            }
          }
        ]
      },
      {
        path:'webauditlog',
        component: WebAuditLogComponent,
        data: {
         breadcrumb: 'Web Audit Log'
        }
      },
      {
        path:'upcomingmicrosoftcsprenewals',
        component: UpcomingMicrosoftCSPRenewalsComponent,
        data: {
         breadcrumb: 'Upcoming MS CSP Renewals'
        }
      },
      {
        path:'NCEOrderReport',
        component: NCEOrderReportComponent,
        data: {
         breadcrumb: 'NCE Orders Report'
        }
      } 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportingRoutingModule { }